module.exports = __webpack_public_path__ + "images/40c7011b8c5713ddb9de65c7835e23ae-ab-mapClusterGrey.png";